import React from 'react';
import { useNavigate } from 'react-router-dom';
import useSearch from '../../hooks/useSearch';
import useTranslate from '../../hooks/useTranslate';
import useGetVideos from '../../hooks/useGetVideos';
import useGetPageConfig from '../../hooks/useGetPageConfig';
import Header from '../../components/Header/Header';
import BannerSlider from '../../components/Slider/BannerSlider';
import VideoCard from '../../components/VideoCard/VideoCard';
import Slider from '../../components/Slider/Slider';
import getBanners from '../../utils/getBanners';
import classNames from 'classnames';
import useGetSearchContents from '../../hooks/useGetSearchContents';
import { _isAMBFooterSubdomain } from '../../constants/conditionals';
import { config } from '../../constants/domainConfig';

export default function Videos() {
    const t = useTranslate();
    const { transformed, getCategoryDetails } = useGetVideos();
    const categories = getCategoryDetails();
    const { searchTerm, ...searchProps } = useSearch();
    const searchVideos = useGetSearchContents(searchTerm, transformed);
    const { rtl } = useGetPageConfig();

    return (
        <>
            <Header searchTerm={searchTerm} {...searchProps} />
            <div className={classNames('home-page', { 'page-layout-amb-footer': _isAMBFooterSubdomain })} dir={rtl ? 'rtl' : 'ltr'}>
                <div className="home-page-banners">
                    <BannerSlider slides={getBanners()} />
                </div>
                <div className="home-page-controls">
                    <div className="title">{t('all_categories')}</div>
                </div>
                <div className={`home-page-contents ${config.product === 'playnixzone' ? 'plaxizone-page-contents' : ''}`}>
                    {searchTerm ? (
                        <CategoryItemsList videos={searchVideos} categories={categories} />
                    ) : (
                        <>
                            <CategoryItemsList videos={transformed} categories={categories} />
                        </>
                    )}
                </div>
            </div>
        </>
    );
}

const CategoryItemsList = ({ videos, categories }) => {
    const t = useTranslate();
    const navigate = useNavigate();
    return (
        <>
            {categories.map((c) => {
                return (
                    <div key={c.categoryId} className="category-wrapper">
                        <div className="category-head">
                            <div className="title">{t(c.categoryName)}</div>
                            <button onClick={() => navigate('/category/video/' + c.categoryId)}>
                                <span>{t('view_all')}</span>
                            </button>
                        </div>
                        <div className="category-videos">
                            <Slider
                                slides={videos
                                    .filter((x) => x.categoryId === c.categoryId)
                                    .map((item) => (
                                        <VideoCard
                                            key={item.videoId}
                                            id={item.videoId}
                                            type={item.itemType}
                                            title={item.videoTitle}
                                            imageURL={item.videoPreview}
                                            onClick={() => navigate('/play/video/' + item.videoId)}
                                        />
                                    ))}
                            />
                        </div>
                    </div>
                );
            })}
        </>
    );
};
